import { AuthCodePayload } from './interfaces';

const IFRAME_ID  = 'AuthLib-iframe';
const AUTHCODE_TIMEOUT = 5000;
let iframe: HTMLIFrameElement;
let onMessage: (event: MessageEvent) => void;

export function createIframe(): HTMLIFrameElement {
  const iframe = document.createElement('iframe');
  const iframeAttributes: { [key: string]: string } = {
    id: IFRAME_ID,
    border: '0',
    frameborder: '0',
    marginwidth: '0',
    marginheight: '0',
    allowtransparency: 'true',
    background: 'transparent',
    scrolling: 'yes',
    style: 'visibility: hidden; width: 0; height: 0; border: 0;'
  };

  Object.keys(iframeAttributes).forEach((attr) => {
    iframe.setAttribute(attr, iframeAttributes[attr]);
  });

  return iframe;
}

export function init(): void {
  iframe = createIframe();
  document.body.appendChild(iframe);
}

export function _getAuthCodePromise(url: string, timeout?: number): Promise<AuthCodePayload> {
  const iframeTimeout = typeof timeout === 'number' ? timeout : AUTHCODE_TIMEOUT;
  if(!document.getElementById(IFRAME_ID)) {
    init();
  }

  if (onMessage) {
    // remove listener if the previous request failed
    window.removeEventListener('message', onMessage);
  }

  return new Promise((resolve, reject) => {
    onMessage = (event: MessageEvent): void => {
      /* istanbul ignore next if */
      if (event.origin !== window.location.origin) {
        return;
      }

      let eventData: AuthCodePayload;
      /* istanbul ignore next catch */
      try {
        eventData = JSON.parse(event.data);
      } catch (err) {
        return;
      }

      /* istanbul ignore next else */
      if (eventData.code && eventData.state) {
        // remove listener if the request was successful
        window.removeEventListener('message', onMessage);
        onMessage = null;
        resolve(eventData);
      }
    }

    window.addEventListener('message', onMessage);

    setTimeout(() => {
      if (onMessage) {
        reject(`No valid auth code response after ${iframeTimeout}ms`)
      }
    }, iframeTimeout);

    iframe.setAttribute('src', url);
  });
}

export async function getAuthCode(url: string, timeout?: number): Promise<AuthCodePayload> {
  try {
    return await _getAuthCodePromise(url, timeout);
  } catch (err) {
    throw new Error(err);
  }
}
